import {safeClone, ViewStream} from 'spyne';
import {PageTraits} from 'traits/page-traits';
import {BlogTraits} from 'traits/blog-traits';
import sdk from '@stackblitz/sdk';
import PageTmplInvestors from './templates/page-investors.tmpl.html';
import {PageDocsItem} from 'components/pages/page-docs-item';

export class PageInvestors extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.isBlog = true;
    props.class = 'app-page-docs';
    props.id = 'l1-investors';

    //console.log('investors is ',props);
    //console.log('quick start page data ',props.appData);
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    //props.template = require("./templates/page-docs.tmpl.html");
    props.template = PageTmplInvestors;
    //props.template = require("./templates/page-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // returfn nexted array(s)
    return [['CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT', 'disposeViewStream']];
  }

  broadcastEvents() {
    return [
      ['a[data-channel=\'ROUTE\']', 'click'],
    ];
  }

  addIframe() {
    sdk.embedProjectId(
        this.props.el$('.docs-content').el,
        'send-info-to-channel',
        {
          openFile: 'index.js',
        },
    );
  }

  addPageDocItems() {
    const addPageItems = (data) => {

      //console.log("DATA INVESTORS IS ", data);
      this.appendView(new PageDocsItem({data}), '.page-content');
    };

    this.props.appData.investorsPageContent.forEach(addPageItems);
  }

  onRendered() {

    // this.blog$CheckToAddBlogItems();
    this.addChannel('CHANNEL_APP_ROUTE', true);
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();

    //this.addIframe();
    //this.appendView(new CodeGeneratorHolder(),  "#code-container");
    //this.appendView(new CodeContainerDetails(), "#code-container");
    //this.appendView(new CodePlaygroundView());
  }
}
